import { initializeAccountPortalState } from '@account/account-portal/lib'
import { ExternalAuthPage, TRANSLATIONS_NAMESPACE_NAME, TRANSLATIONS_PROJECT_NAME } from '@account/external-auth-mf'
import { createReactMicrofrontendModule, hasIsomorphicData, setIsomorphicData } from '@crystal/core'
import { loadTranslations } from '@crystal/translator'

export const { mount, unmount, update } = createReactMicrofrontendModule(ExternalAuthPage, {
  async beforeMount({ context }) {
    initializeAccountPortalState({ force: true })

    // pre-load and cache translations
    // so that they are available as soon as the app is mounted
    const translationsKey = `translations_${TRANSLATIONS_PROJECT_NAME}-${TRANSLATIONS_NAMESPACE_NAME}-${context.locale}-`
    if (!hasIsomorphicData(translationsKey)) {
      await loadTranslations(TRANSLATIONS_PROJECT_NAME, TRANSLATIONS_NAMESPACE_NAME, context.locale)
        .then(data =>
          setIsomorphicData(translationsKey, {
            data,
          }),
        )
        .catch(() => null)
    }
  },
})
